import React from "react";

const SvgPlay = props => <svg viewBox="0 0 204 204" fill="none" {...props}><g opacity={0.8}><circle cx={102} cy={102} r={102} fill="currentColor" /><path fillRule="evenodd" clipRule="evenodd" d="M93.84 79.52a1 1 0 0 1 1.6-.8l29.973 22.48a1 1 0 0 1 0 1.6L95.44 125.28a1 1 0 0 1-1.6-.8V79.52z" fill="#432352" /></g></svg>;

export default SvgPlay;